<template>
    <section class="container bg-white my-5 p-5">



        <div class="row justify-content-center align-items-top">
            <div class="col-12">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-12 col-md-5">
                            <!--
                            <h5>Neu hier?</h5>
                            <p>Dann werde Teil der smarten FAAREN Familie und sei mobil ohne den nervigen
                                Stress,
                                den Autobesitz normalerweise mit sich bringt.</p>

                            <a :href="registerUrl"
                               class="btn btn-primary">Neues Konto anlegen</a>
                               -->

                        </div>

                        <div class="col-12 col-md-6 offset-md-1">
                            <h5>Partner-Login</h5><br>

                            <div class="container-fluid">
                                <form method="post" :action="loginUrl">
                                    <div class="form-row">
                                        <div class="form-group col-12">
                                            <label for="loginEmail">E-Mail-Adresse</label>
                                            <input type="text" id="loginEmail" name="email"
                                                   placeholder="E-Mail-Adresse"
                                                   class="form-control">
                                        </div>
                                        <div class="form-group col-12">
                                            <label for="loginPassword">Passwort</label>
                                            <div class="input-group ">
                                                <input :type="passwordFieldType" id="loginPassword" name="password"
                                                       placeholder="Passwort"
                                                       class="form-control form-control border-right-0">
                                                <div class="input-group-append"
                                                     v-on:click="togglePasswordVisibility">
                                                    <span class="input-group-text bg-white border-left-0"><i
                                                            class="far fa-eye"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group form-check">
                                                <input type="checkbox" class="form-check-input" id="remember" name="remember">
                                                <label class="form-check-label" for="remember">Angemeldet bleiben</label>
                                            </div>
                                        </div>

                                    </div>

                                    <input v-if="belongsToCheckout" type="hidden" name="identifier" :value="identifier">
                                    <csrf-field :token="csrfToken"></csrf-field>

                                    <button type="submit" class="btn btn-outline-primary">Einloggen</button>
                                    <a :href="passwordForgottenUrl" class="btn btn-link">Passwort vergessen?</a>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </section>
</template>

<script>
    export default {
        name: "LoginOrRegister",
        props: [
            'loginUrl',
            'registerUrl',
            'belongsToCheckout',
            'csrfToken',
            'identifier',
            'passwordForgottenUrl'
        ],
        data(){
            return {
                passwordFieldType: 'password'
            }
        },
        methods: {
            togglePasswordVisibility(){
                this.passwordFieldType = (this.passwordFieldType === 'password') ? 'text' : 'password';
            }
        }
    }
</script>

<style scoped>

</style>
